import {
    NODE_STATUS_REQUEST_GET,
    NODE_STATUS_RESPONSE_GET_SUCCESS,
    NODE_STATUS_RESPONSE_GET_FAIL,

  } from "../../../constants/maintenance/systemHealth/nodeStatusConstants";
  
  export const nodeStatusReducer = (state = { nodeStatus: {} }, action) => {
    switch (action.type) {
      case NODE_STATUS_REQUEST_GET:
        return {
          ...state,
          loading: true,
        };
      case NODE_STATUS_RESPONSE_GET_SUCCESS:
        return {
          ...state,
          loading: false,
          nodeStatus: action.payload,
        };
      case NODE_STATUS_RESPONSE_GET_FAIL:
        return {
          ...state,
          loading: false,
          error: action.payload,
        };
      default:
        return state;
    }
  };
  